import { _ as _define_property } from "@swc/helpers/_/_define_property";
import * as approvalMethodNoticePeriodModel from './approval-method-notice-period';
import * as relationshipModel from './relationship';
import { RelationshipStatus } from './relationship';
import { ServiceSource } from './service/model';
export class AgreementDataModel {
    static make(data) {
        var _data_amendmentsApprovalMethod;
        return new AgreementDataModel(data.netTerms, data.autoPayment, data.status, data.effectiveDate, data.daysToEffectiveDate, (_data_amendmentsApprovalMethod = data.amendmentsApprovalMethod) !== null && _data_amendmentsApprovalMethod !== void 0 ? _data_amendmentsApprovalMethod : null);
    }
    static fromRelationship(relationship) {
        return new AgreementDataModel(relationshipModel.actualNetTerms(relationship), !relationship.allowManualPayments, relationship.status, relationship.effectiveDate, relationship.daysToEffectiveDate, relationship.amendmentsApprovalMethod);
    }
    static fromDraft(draft) {
        return new AgreementDataModel(draft.netTerms(), !draft.allowManualPayments(), RelationshipStatus.Pending, draft.effectiveDate(), 0, draft.amendmentsApprovalMethod());
    }
    setNetTerms(netTerms) {
        return new AgreementDataModel(netTerms, this.autoPayment, this.status, this.effectiveDate, this.daysToEffectiveDate, this.amendmentsApprovalMethod);
    }
    amendmentAutoAccepts() {
        return this.amendmentsApprovalMethod != null && approvalMethodNoticePeriodModel.isAutoApproval(this.amendmentsApprovalMethod);
    }
    isActiveAgreement() {
        return this.status !== RelationshipStatus.Pending;
    }
    isPending() {
        return this.status === RelationshipStatus.Pending;
    }
    serviceSource() {
        return this.isActiveAgreement() ? ServiceSource.Amendment : ServiceSource.Draft;
    }
    constructor(netTerms, autoPayment, status, effectiveDate, daysToEffectiveDate, amendmentsApprovalMethod){
        _define_property(this, "netTerms", void 0);
        _define_property(this, "autoPayment", void 0);
        _define_property(this, "status", void 0);
        _define_property(this, "effectiveDate", void 0);
        _define_property(this, "daysToEffectiveDate", void 0);
        _define_property(this, "amendmentsApprovalMethod", void 0);
        this.netTerms = netTerms;
        this.autoPayment = autoPayment;
        this.status = status;
        this.effectiveDate = effectiveDate;
        this.daysToEffectiveDate = daysToEffectiveDate;
        this.amendmentsApprovalMethod = amendmentsApprovalMethod;
    }
}
